import React, { useState, useEffect, useCallback, useRef } from 'react';
import { string, func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

function millisecondsToDateObject(milliseconds) {
  const date = { day: 0, hour: 0, minute: 0, second: 0 };
  date.day = Math.floor((milliseconds / 86400000) % 30);
  date.hour = Math.floor((milliseconds / 3600000) % 24);
  date.minute = Math.floor((milliseconds / 60000) % 60);
  date.second = Math.floor((milliseconds / 1000) % 60);
  return date;
}

function CountdownDate({ dateTo, onCountdownEnd }) {
  const { t } = useTranslation(['purchase']);

  const calculateTimeLeft = useCallback(() => {
    const currentDate = dayjs();
    const targetDate = dayjs(dateTo);

    const diff = targetDate - currentDate;
    const isPastDateTo = diff <= 0;

    const { day, hour, minute, second } = millisecondsToDateObject(
      isPastDateTo ? 0 : diff,
    );

    return {
      day,
      hour,
      minute,
      second,
    };
  }, [dateTo]);
  const timer = useRef();
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    timer.current = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer.current);
  }, [calculateTimeLeft]);

  useEffect(() => {
    // if get all values is 0, means the date is past, stop timer.
    if (Object.values(timeLeft).filter(Boolean).length === 0) {
      if (typeof onCountdownEnd === 'function') onCountdownEnd();
      clearInterval(timer.current);
    }
  }, [onCountdownEnd, timeLeft]);

  return <div>{t('purchase.limitedCountdown', timeLeft)}</div>;
}

CountdownDate.propTypes = {
  dateTo: string.isRequired,
  onCountdownEnd: func,
};

CountdownDate.defaultProps = {
  onCountdownEnd: undefined,
};

export default CountdownDate;
